import { Block, Period, PeriodTabs, Spinner, Text } from '@/ui-kit'
import { OverlayScrollBars } from '@/ui-kit/components/OverlayScrollbars'
import { formatNumber } from '@/utils'
import { Trans } from '@lingui/react/macro'
import clsx from 'clsx'
import { useMemo, useState } from 'react'
import { useFetchUserSectors } from '../api/useFetchUserDomains'
import styles from './TopDomains.module.css'

export const TopDomains = () => {
  const [period, setPeriod] = useState<Period>('day')
  const { data: domains } = useFetchUserSectors(period)

  const items = useMemo(
    () =>
      domains?.[period]
        ? domains[period]
            .map(({ sector, jobs, points }) => ({ sector, jobs: Number(jobs), points: Number(points) }))
            .sort((a, b) => b.points - a.points)
        : [],
    [domains, period]
  )

  return (
    <Block>
      <div className="max-mobile:flex-col max-mobile:items-stretch flex items-center justify-between">
        <div className="flex">
          <Text className="mr-4 flex pr-4" type="subtitle-semibold">
            <Trans>Top domains</Trans>
          </Text>
        </div>
        <PeriodTabs className="max-mobile:my-0 max-mobile:mt-3 -my-[2px]" value={period} onChange={setPeriod} />
      </div>
      <div className="-mx-4 -mb-3">
        <OverlayScrollBars>
          <div className="flex flex-col px-4 pb-3" style={{ maxWidth: 'calc(100vw - 49px)' }}>
            <table className={clsx(styles.table, 'mt-4 w-full min-w-[500px]')}>
              <thead>
                <tr>
                  <th className={styles.th}>
                    <Text className="text-gray-90 whitespace-nowrap">
                      <Trans>Domain</Trans>
                    </Text>
                  </th>
                  <th className={styles.th}>
                    <Text className="text-gray-90 whitespace-nowrap">
                      <Trans>Jobs Completed</Trans>
                    </Text>
                  </th>
                  {/*  <th className={clsx(styles.th, 'relative')}>
                    {/* FIXME: something is happening here, and I'm not sure what it is }
                    <div className="backgroundColorBackground absolute right-0 top-[44px] h-[1px] w-4" />
                    <Text className="text-gray-90 whitespace-nowrap">Points Earned</Text>
                  </th> */}
                </tr>
              </thead>
              <tbody className="pt-5">
                {items.map(({ sector, jobs }, index) => (
                  <tr key={index} className={styles.row}>
                    <td className={styles.cell}>
                      <Text>{sector}</Text>
                    </td>
                    <td className={styles.cell}>
                      <Text>{formatNumber(jobs, 0)}</Text>
                    </td>
                    {/* <td className={styles.cell}>
                      <Text>{formatNumber(points, 0)}</Text>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
            {domains?.[period] === undefined ? (
              <div className="flex h-20 items-center justify-center">
                <Spinner />
              </div>
            ) : (
              !items.length && (
                <Text className="text-gray-90 mx-auto mt-2">
                  <Trans>No data available yet</Trans>
                </Text>
              )
            )}
          </div>
        </OverlayScrollBars>
      </div>
    </Block>
  )
}
